import { Contact, Person } from '@amzn/red-velvet-api';

export function getPersonFullName(person: { firstName?: string; lastName?: string }): string {
  return `${person.firstName ?? ''} ${person.lastName ?? ''}`.trim();
}

/**
 * Formats a contact's name for display: "FirstName LastName (@alias)".
 * Falls back to "(@alias)" if name is empty.
 */
export function formatContactDisplayName(name: string | undefined, alias: string): string {
  return name ? `${name} (@${alias})` : `(@${alias})`;
}

/**
 * Converts a PAPI Person result into a Contact with name, email, and alias.
 */
export function personToContact(person: Person, fallbackAlias?: string): Contact {
  return {
    name: getPersonFullName(person),
    email: person.primaryEmail ?? '',
    alias: person.alias ?? fallbackAlias ?? '',
  };
}

/**
 * Extracts the local part (alias) from an email address.
 * Returns undefined when the email is missing, malformed, or has an empty local part.
 */
export function getAliasFromEmail(email: string | undefined): string | undefined {
  if (!email) return undefined;
  const at = email.indexOf('@');
  if (at <= 0) return undefined;
  return email.substring(0, at);
}
